import { useEffect } from "react";
import { useContent } from "../contexts/ContentContext";

export default function SeoHead() {
  const { content } = useContent();
  const s = content?.settings || {};

  useEffect(() => {
    if (!content) return;
    const title = s.tab_title || s.institute_name || "Sunbright Scholars Academy";
    if (title && document.title !== title) {
      document.title = title;
    }

    const desc = s.meta_description;
    if (desc) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", desc);
    }

    if (s.logo_url) {
      let icon = document.querySelector('link[rel="icon"]');
      if (!icon) {
        icon = document.createElement("link");
        icon.setAttribute("rel", "icon");
        document.head.appendChild(icon);
      }
      icon.setAttribute("href", s.logo_url);
    }
  }, [content, s.tab_title, s.institute_name, s.meta_description, s.logo_url]);

  return null;
}
